import { tokens as appTokens } from '../../styles/tokens'

/**
 * Design tokeny modulu Apex Ops.
 *
 * Ve standalone appce (repo apex-ops) si modul nesl vlastní paletu i vlastní MUI theme.
 * Po integraci do portilio-fe je to na škodu — modul by ignoroval vzhled aplikace
 * (výchozí / luxusní / dolarový / půlnoční) i automatickou volbu podle teritoria
 * a v menu by vypadal jako cizí stránka. Tokeny proto jen přemapují tokeny aplikace
 * do tvaru, na který jsou komponenty modulu zvyklé; vlastní MUI theme si modul nedělá
 * (viz OpsPage) a dědí ho z aplikace. Aplikační theme přebíjí stejnou sadu komponent,
 * kterou dřív řešil opsTheme (Button, OutlinedInput, TableCell, Dialog, Menu, Tooltip).
 *
 * Čte se přes gettery schválně. `applyThemeTokens` v styles/tokens přiřazuje
 * `tokens.color`, `tokens.radius` a `tokens.shadow` NOVÉ objekty, takže hodnota
 * odečtená při načtení modulu by zůstala zamrzlá na výchozí paletě a přepnutí
 * teritoria ani vzhledu by se v modulu neprojevilo.
 *
 * Když se změní paleta aplikace, změní se i modul. Nepřidávat sem vlastní barvy.
 */
export const tokens = {
  get primary() {
    return appTokens.color.primary
  },
  get neutral() {
    return appTokens.color.neutral
  },
  get success() {
    return appTokens.color.success
  },
  get warning() {
    return appTokens.color.warning
  },
  get error() {
    return appTokens.color.error
  },
  get background() {
    return appTokens.color.neutral[50]
  },
  /** Komponenty modulu očekávají čísla (`${...}px`, style borderRadius), aplikace drží '6px'. */
  get radius() {
    return {
      sm: parseInt(appTokens.radius.sm, 10),
      md: parseInt(appTokens.radius.md, 10),
      lg: parseInt(appTokens.radius.lg, 10),
    }
  },
  get shadow() {
    return appTokens.shadow
  },
  get focus() {
    return { shadow: appTokens.focus.shadow }
  },
  get font() {
    return appTokens.font.family
  },
}
